import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  submitButton: {
    id: 'containers.paymentinfo.submitButton',
    defaultMessage: 'Save',
  },
  validationRequiredField: {
    id: 'containers.paymentinfo.validation.required.field',
    defaultMessage: 'Field value required',
  },
  placeholderAccountOwner: {
    id: 'containers.paymentinfo.form.placeholder.accountOwner',
    defaultMessage: 'Account Owner',
  },
  placeholderSwift: {
    id: 'containers.paymentinfo.form.placeholder.swift',
    defaultMessage: 'SWIFT',
  },
  placeholderIban: {
    id: 'containers.paymentinfo.form.placeholder.iban',
    defaultMessage: 'IBAN',
  },
  placeholderCountry: {
    id: 'containers.paymentinfoform.placeholder.country',
    defaultMessage: 'Bank Country',
  },
  placeholderBankName: {
    id: 'containers.paymentinfo.form.placeholder.bankName',
    defaultMessage: 'Bank Name',
  },
  successText: {
    id: 'containers.paymentinfo.form.successText',
    defaultMessage: 'Saved successfully!',
  },
});



// WEBPACK FOOTER //
// ./src/containers/PaymentInfo/messages.js